import { connect } from 'react-redux'
import ProgressiveImageComponent from "../components/ProgressiveImageComponent";

const mapStateToProps = (state, ownProps) => ({
})

const mapDispatchToProps = (dispatch, ownProps) => ({
})

const ProgressiveImage = connect(
  mapStateToProps,
  mapDispatchToProps
)(ProgressiveImageComponent)

export default ProgressiveImage



// WEBPACK FOOTER //
// ./src/containers/ProgressiveImage.js